export default {
    ServerURL:'https://idealtsa.herokuapp.com/',
    Token:'kamjndj&^$2',
    VerifyEmail:'ekmn@#$%08g!~{)',
    SITE_KEY : '6Lc80qggAAAAAAhJ6pydj96aOSb81qfs9T1C3kKH',
    ClientURL:'http://idealtsa.com'
  };